export default {
  header: 'Lager per produkt',
  release: 'Frigi',
  empty: 'Ingen AGP-poster.',
  product: 'Produkt',
  bottleSize: 'Flaskestørrelse',
  inAgp: 'I AGP',
  bottled: 'Flasket',
  released: 'Frigitt',
  batches: 'Batcher',
  emptyBatch: 'tom',
};
